import React from 'react';

import * as s from './SidebarCard.css';

export interface ISidebarCardParams {
  children: React.ReactNode;
  theme?: 'var(--theme-gray)' | 'var(--theme-white)';
}

/**
 * Декоратор блоков в сайдбаре
 */
export const SidebarCard = ({ children, theme = 'var(--theme-white)' }: ISidebarCardParams) => (
  <div className={`${s['wrapper']} ${s[`_${theme}`]}`}>{children}</div>
);
